module.exports = __webpack_public_path__ + "static/media/exclusive.b96e3d25.svg";